import { inject, Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { RouterStateSnapshot, TitleStrategy } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Store } from "@ngrx/store";
import accountSelectors from "@state/account/selectors";
import { State } from "@state/models";

@UntilDestroy()
@Injectable({ providedIn: "root" })
export class DynamicTitleStrategy extends TitleStrategy {
  titleService = inject(Title);
  account$ = this.store.select(accountSelectors.currentAccount);

  constructor (private store: Store<State>) {
    super();
  }

  override updateTitle (routerState: RouterStateSnapshot): void {
    const title = this.buildTitle(routerState);

    this.account$.pipe(untilDestroyed(this)).subscribe(async account => {
      if (account) {
        if (title !== undefined) {
          this.titleService.setTitle(`${account.name} | ${title}`);
        } else {
          this.titleService.setTitle(`${account.name}`);
        }
      } else {
        if (title !== undefined) {
          this.titleService.setTitle(title);
        } else {
          this.titleService.setTitle("Huntag");
        }
      }
    });

  }
}
